export const standardColours = {
  black: '#000',
  darkerGrey: '#484848',
  darkGrey: '#969696',
  grey: '#E5E5E5',
  lightGrey: '#F3F3F3',
  lighterGrey: '#F9F9F9',
  white: '#FFF',
  transparentBlack: value => {
    return `rgba(0, 0, 0, ${value})`;
  },
  transparentWhite: value => {
    return `rgba(255, 255, 255, ${value})`;
  },
  transparent: 'rgba(255, 255, 255, 0)',
};

export const brandColours = {
  primary: '#80D8D0', // greenish blue
  secondary: '#E1FAF7', // light greenish blue
  tertiary: '#2AB9AC', // dark greenish blue
  quaternary: '#EBF6F5', // lighter greenish blue
  quinary: '#9AD9F2', // light blue
  senary: '#D7E6EA', // lighter blue
  septenary: '#156962', // dark green
  octonary: '#E9FCE6', // light green
  nonary: '#FF595E', // dark red
  denary: '#FEE1E2', // light red
  duodenary: '#FFD641', // yellow
  dodectenary: '#58A1CA', // blue

  transparentSecondary: value => {
    return `rgba(225, 250, 247, ${value})`;
  },
};

export const rangeColours = {
  care: '#B7D4FF', // light blue
  essential: '#E6E6E6', // light grey
  everyDay: '#DBF4FF', // lighter blue
  luxury: '#F1DFFF', // light purple
};

export const elementColours = {
  textColour: standardColours.darkerGrey,
};
